import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Grid from "@material-ui/core/Grid";
import BangladeshFlag from "../assets/imgs/Bangladesh-Flag.jpg";
import UsaIcon from "../assets/imgs/Usa-Icon.png";
import ArrowForwardRoundedIcon from "@material-ui/icons/ArrowForwardRounded";
import img_1 from "../assets/imgs/program1/deenconnect-hhc-usa-project-limb.jpeg";
import img_2 from "../assets/imgs/program1/hhc-usa-project-Antibody-testing.png";
import img_3 from "../assets/imgs/deenconnect-hhc-usa-project-wheel-chair-amjad-hossain.jpeg";
import img_4 from "../assets/imgs/program1/antibody Test.jpeg";
import img_5 from "../assets/imgs/program1/deenconnect-hhc-usa-project-fire-explosion BM-Depot-Sujon-Baharl.jpeg";
import img_6 from "../assets/imgs/program1/BM-Depot-CheckGivingtoSahadat.Mom.jpeg";

import {
  Section,
  PageTitleOne,
  CardFifteen,
  ModalFour,
} from "master-react-lib";
import CTAOneSection from "./CTAOneSection";
import Activities from "./Activities";
import VideoFromTheField from "./VideoFromTheField";
import Projects from "./Projects";

import "../assets/css/style.css";

function MedicalSupportProgramDetailsPage(props) {
  const [open_1, setOpen_1] = React.useState(false);
  const handleOpen_1 = () => setOpen_1(true);
  const handleClose_1 = () => setOpen_1(false);

  const [open_2, setOpen_2] = React.useState(false);
  const handleOpen_2 = () => setOpen_2(true);
  const handleClose_2 = () => setOpen_2(false);

  const [open_3, setOpen_3] = React.useState(false);
  const handleOpen_3 = () => setOpen_3(true);
  const handleClose_3 = () => setOpen_3(false);

  const [open_4, setOpen_4] = React.useState(false);
  const handleOpen_4 = () => setOpen_4(true);
  const handleClose_4 = () => setOpen_4(false);

  const [open_5, setOpen_5] = React.useState(false);
  const handleOpen_5 = () => setOpen_5(true);
  const handleClose_5 = () => setOpen_5(false);

  const usaProjectsUsa = [
    {
      img: img_1,
      titleTop: "",
      flag: BangladeshFlag,
      titleTopLink: "/programt-details",
      title: "Artificial Limb Support",
      description:
        "Our vision to ensure the inclusion of girls and boys, women with disabilities into ",
      link: "/limb-support-project-details",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_1,
    },

    {
      img: img_2,
      titleTop: "",
      flag: BangladeshFlag,
      title: "Covid-19",
      description:
        " COVID 19 - In Bangladesh, amid ongoing COVID-19 Pandemic threatens to cause a humanitarian crisis. ",
      link: "#",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_2,
    },

    {
      img: img_3,
      titleTop: "",
      flag: BangladeshFlag,
      title: "Wheelchair for Amputees",
      description:
        "With an estimated 75 million people around the world todayin need of a wheelchair, Free  ",
      link: "#",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_3,
    },

    {
      img: img_4,
      titleTop: "",
      flag: UsaIcon,
      title: "Covid Anti-Body Testing",
      description:
        "The first free #COVID19 Antibody Testing mobile clinic  has been completed at  Brooklyn, NY . Organized by ",
      link: "#",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_4,
    },

    {
      img: img_5,
      titleTop: "",
      flag: BangladeshFlag,
      title: "Mobile Medical Unit & Ambulance Service",
      description: "UPCOMING PROJECT:  Mobile medical units bring relief ",
      link: "#",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_5,
    },

    {
      img: img_6,
      titleTop: "",
      flag: BangladeshFlag,
      title: "Mobile Medical Unit & Ambulance Service",
      description: "UPCOMING PROJECT:  Mobile medical units bring relief to  ",
      link: "#",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_5,
    },
  ];

  const eventDetails = [
    {
      img: img_1,
      title: "Artifical Limb Support",
      Location: "Location: Bangladesh",
      description: (
        <p>
          Our vision to ensure the inclusion of girls and boys, women and men
          with disabilities into mainstream society. HHC offer grants in the
          form of activewear prosthetics artificial limbs to those who have
          suffered the loss of a limb . Everyday we work to give people hope and
          a chance for a better life.{" "}
        </p>
      ),
      open: open_1,
      handleClose: handleClose_1,
    },
    {
      img: img_2,
      title: "Covid-19",
      description: (
        <p>
          The economic shutdown sparked threatens millions of livelihoods in the
          country imminently. Struggling to put meals on the table, specially
          Public health system in Chittagong is vulnerable. There are not enough
          Corona Unit, Protective equipments for first responder. People dying
          because of shortage of Oxygen supply. <br /> <br />
          The economic shutdown sparked threatens millions of livelihoods in the
          country imminently. Struggling to put meals on the table, specially
          Public health system in Chittagong is vulnerable. There are not enough
          Corona Unit, Protective equipments for first responder.Given lockdown
          has disrupted the markets the poor people are left to fend for
          themselves. It is either avoid the plague or die of hunger trying. Not
          enough work nor supplies. <br />
          <br />
          We have donate to Protecting Gera for First responders like Doctor
          Nurses, Police, Funeral service organaization like Al Manahill
          Foundation orsimilar organizations.,and Public Hospital like General
          Hospital, Maa O Shishu Hospital, Chest Disease Hospital, Fauzdarhat,
          Chittagong. We are thankful and humbled by your unconditional support.
          We can’t thank you enough for your support and cooperation in this
          time of crisis of COVID-19. <br /> <br /> করোনার সর্বগ্রাসী সংক্রমণে
          আবারো মৃত্যুর মিছিলে যোগ হচ্ছে হাজার হাজার মানুষ , লকডাউনের যাথাকলে
          নিষ্পেষিত অসহায় জনগণ। আবারো হাসপাতালে আই সি ইউ ও অক্সিজেনের সংকট
          তীব্র। <br />
          <br /> গত বৎসর করোনার মহামারীতে সমস্ত পৃথিবী যখন পর্যদুস্ত ! তীব্র
          অক্সিজেন সংকটে যখন বাংলাদেশ লাশের মিছিল , আতঙ্কগ্রস্ত হয়ে দিগ্বিদিক
          ঘুরছে একটু শ্বাস নেওয়ার জন্য, একটা হাসপাতাল বেডের জন্য , ঠিক ঐ
          সংকটকালীন সময়ে আপনাদের আর্থিক ও শারীরিক সহযোগিতায় "হেল্পিং হ্যান্ড
          ফর চিটাগোনিয়ান" নামের এই সংগঠনটি নিউইয়র্কে জন্ম নিয়ে তড়িৎ গতিতে
          চট্টগ্রামের প্রতিটি উপজেলায় ও নগর হাসপাতালে অক্সিজেন এবং চিকিৎসা
          সামগ্রী সরবরাহ করে, দেশে একদল মানবতাবাদী নিজের জীবনকে বাজি রেখে
          প্রতন্ত অঞ্চলে ছুটে যায়। নাড়ির টানে উত্তর আমেরিকার প্রবাসী
          চট্টগ্রামবাসী আমাদের ডাকে সাড়া দিয়ে আর্তমানবতার সেবায় অসম্ভবকে
          সম্ভব করেছেন। <br />
          <br />
          আবারো গভীর সংকট অতিক্রম করছে দেশ। আমরা ব্যক্তিগত ভাবে অনেকে সাহায্য
          সহোযোগিতা করছি , কিন্তু দেশ ও সমাজ বিনির্মানে ও সংকটকালীন সময়ে <br />
          <br /> সঙ্ঘবদ্ধ ভাবে অনেক বেশি সহযোগিতা করা যায়। আপনাদের ক্ষুদ্র
          ক্ষুদ্র সাহায্য একদিন মহীরুহে পরিণতি হৰে। <br />
          যে_প্রজেক্ট_গুলোতে সহযোগিতা করেছি এবং করব :
          <br />
          1: চট্টগ্রামের প্রতিটি উপজেলা স্বাস্থ কমপ্লেক্সে অক্সিজেন
          কন্সেন্ট্রেটর সরবরাহ
          <br />
          2: সদর হাসপাতাল, ফিল্ড হাসপাতাল , উপজিলা হাসপাতাল ও প্রেস ক্লাবে PPE,
          MASK, GLOVES, THERMOSCAN বিতরণ
          <br />
          3: লাশ দাফনে সহযোগিতা
          <br />
          3: নিউ ইয়র্কে এন্টিবডি টেস্টিংএ ভ্রাম্ম্যমান ক্লিনিকে ভলোন্টিয়ার
          সহযোগিতা
        </p>
      ),
      open: open_2,
      handleClose: handleClose_2,
    },
    {
      img: img_3,
      title: "Wheelchair for Amputees",
      description: (
        <p>
          With an estimated 75 million people around the world today in need of
          a wheelchair, Free Wheelchair Mission continues our mission to provide
          mobility to people living with disabilities. <br />
          Free Wheelchair Mission continues its focus and commitment on becoming
          a leading provider of mobility in developing countries, but beyond
          placing recipients in a wheelchair, Free Wheelchair Mission is
          bringing transformation that opens doors to education, employment
          opportunities, and community that these individuals only dreamed of
          before receiving the gift of mobility. <br />
          <br />
          Wheelchairs provide people with disabilities the mobility, inclusion,
          and care they deserve and need. Our ministry provides quality
          wheelchairs that are safety-tested and tailored to meet the needs and
          size of each individual, giving people the opportunity to live a
          fulfilling life!
        </p>
      ),
      open: open_3,
      handleClose: handleClose_3,
    },
    {
      img: img_4,
      title: "Covid Anti-Body Testing",
      description: (
        <p>
          The first free #COVID19 Antibody Testing mobile clinic has been
          completed at Brooklyn, NY . Organized by FOBANA, HELPING HAND FOR
          CHITTAGONIAN INC and Bangladeshi American Police Association (BAPA),
          conducted by Marks Home Care. From 11 am to 5 pm, hundreds of people,
          both local and foreign, lined up to receive this vital health care.
          <br />
          <br />
          নিউইয়র্ক ব্রুকলিনের বাংলাদেশ অধ্যুষিত চার্চ এবং ম্যাকডোনাল্ড
          এভিনিও'তে ব্যাপক উৎসাহ উদ্দীপনা নিয়ে প্রথমবারের মতো ফ্রি
          #COVID_19_Antibody _Testing সম্পন্ন হয়েছে। FOBANA , HELPING HAND FOR
          CHITTAGONIAN এবং Bangladeshi American Police Association (BAPA) এর
          সৌজন্যে আয়োজিত, মার্কস হোম কেয়ার দ্বারা পরিচালিত হয় ।সকাল ১১ টা
          থেকে বিকাল ৫ টা পর্যন্ত দেশি বিদেশী কয়েকশো মানুষ লম্বা লাইন দিয়ে এই
          গুরুত্বপূর্ণ স্বাস্থ্যসেবা গ্রহন করেন। হেল্পিং হ্যান্ড ফর চিটাগোনিয়ান
          এর ভলোন্টিয়ার এই মহৎ কাজে সার্বিক ভাবে সহযোগিতা করেন।
        </p>
      ),
      open: open_4,
      handleClose: handleClose_4,
    },

    {
      img: img_5,
      title: "Mobile Medical Unit & Ambulance Service",
      description: (
        <p>
          UPCOMING PROJECT: Mobile medical units bring relief to villagers who
          are either unable to afford medical care or reside in rural areas that
          oftentimes are unreachable during natural disasters. Emergency medical
          professionals, enabled with ambulatory training, increase their
          capacity to cope with any given emergency through these services. This
          also helps provide a means for patients to successfully attend
          rehabilitation and therapy sessions by securing transportation. HHC
          have a future plan to provide Mobile Medical Unit & Ambulance
          Services,
        </p>
      ),
      open: open_5,
      handleClose: handleClose_5,
    },
    {
      img: img_6,
      title: "Mobile Medical Unit & Ambulance Service",
      description: (
        <p>
          UPCOMING PROJECT: Mobile medical units bring relief to villagers who
          are either unable to afford medical care or reside in rural areas that
          oftentimes are unreachable during natural disasters. Emergency medical
          professionals, enabled with ambulatory training, increase their
          capacity to cope with any given emergency through these services. This
          also helps provide a means for patients to successfully attend
          rehabilitation and therapy sessions by securing transportation. HHC
          have a future plan to provide Mobile Medical Unit & Ambulance
          Services,
        </p>
      ),
      open: open_5,
      handleClose: handleClose_5,
    },
  ];

  return (
    <div>
      <Header />

      <div className="InnerPageCtn">
        <PageTitleOne
          Title="Program Details"
          color="#fff"
          backgroundcolor="#33B651"
        />

        <Section
          background="#fff"
          //ContainerWidth=""
          Spacing="40px"
          Container={
            <div className="SectionContainer">
              <h1 className="2ndTitle TextCetner">Medical Supports</h1>
              <div className="ParaSection">
                <p>
                  COVID-19 PANDEMIC EMERGENCY- Our project is dedicated to
                  providing much needed healthcare facilities, medical aid and
                  participate in this global effort to protect the most
                  vulnerable members of our communities both in the United
                  States and Bangladesh.
                </p>
                <div className="TopBannerCtn">
                  <img src={img_4} />
                </div>

                <p>
                  Proper healthcare systems are still unattainable luxuries in
                  some regions of the world. HHC works to increase access to the
                  best quality health care to those in need in Bangladesh and US
                  . We plan provide free medical camps in the several rural
                  places in Bangladesh. Providing medical equipments, Oxygen
                  Concentrator, Protecting gear to the Hospital , first
                  responders in Bangladesh, it is one of our large project to
                  fight against Corona virus and health care system.
                </p>
                <p>
                  We distributed Personal Protective Equipment (PPE) to medical
                  service providers including doctors and nurses are at the
                  forefront of this pandemic response and are at high risk of
                  infection. Provided Oxygen concentrator, PPE including masks,
                  hand sanitizer, gloves, thermometer, Googles, and disinfectant
                  material to health service facilities with the highest need.{" "}
                </p>
              </div>
            </div>
          }
        />

        <Section
          background="#F6FBFE"
          //ContainerWidth=""
          Spacing="40px"
          Container={
            <div className="SectionContainer">
              <h1 className="2ndTitle"> Projects</h1>
              <div className="devider"></div>

              <div>
                <CardFifteen
                  cardFifteenData={usaProjectsUsa}
                  col={4}
                  colSpacing={2}
                  titleColor="#fff"
                  Titlebackground="#0B132B"
                  discriptionColor="#707070"
                  buttonLabel="Read More"
                  //ReadmoreIcon={<ArrowForwardRoundedIcon />}
                  ReadmoreColor="#FF6200"
                  BottomLineColor="#FF6200"
                  BottomLine={true}
                  border="border"
                  titleTopLeftcolor="#FF6200"
                  // == Button Style =====//
                  label="Make a donation"
                  link="https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories"
                  target="blank"
                  path="https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories"
                  arrowIcon={<ArrowForwardRoundedIcon />}
                  arrowStatus={true}
                  arrowColor="#fff"
                  buttoncolor="#33B651"
                  width="100%"
                  height="50px"
                  slider
                  borderRadius="0px"
                  color="#fff"
                  fontWeight="600"
                  //textAlign="center"

                  Buttonlink="https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories"
                />
              </div>
            </div>
          }
        />

        <Activities />
        <VideoFromTheField />
        <Projects />
        <CTAOneSection />
      </div>
      {eventDetails.map((item, i) => (
        <ModalFour
          open={item.open}
          handleClose={item.handleClose}
          width="910px"
          height="750px"
          title="Project details"
          img={item.img}
          imgstatus={true}
          // location="New York, United States"
          // Program="Covid-19"
          // Programlink="/programt-details"

          buttonlabel="DONATE NOW"
          buttoncolor="#33B651"
          buttonarrowStatus="true"
          buttonarrowColor="#fff"
          color="#fff"
          buttonlink="https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories"
          target="_blank"
          buttonwidth="80%"
          buttonheight="40px"
          ButtonRadius="4px"
          textAlign="center"
          // LocationStatus={true}
          // eventTitle="Personal protective equipment (PPE)"
          // eventTitleStatus={true}

          body={
            <div>
              <h2>{item.title}</h2>
              {/* <h3>{item.Location}</h3> */}
              <p>{item.description}</p>
            </div>
          }
        />
      ))}

      <Footer />
    </div>
  );
}

export default MedicalSupportProgramDetailsPage;
